<template>
  <PageContainer size="large">
    <View direction="column" gap="sm">
      <PageBackNav
        :teleport-slot-id="headerTeleportSlot"
        :desktop-back-title="'Back to Application'"
        @back-nav="goBack()"
      />

      <TransUnionViewReport
        :is-loading="reportRef === undefined"
        :report="reportRef"
        :type="reportType"
        :error="undefined"
      />
    </View>
  </PageContainer>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

import { TransUnionProductType, TransUnionViewReport } from '@tallo/applications';
import { PageBackNav, PageContainer, View } from '@tallo/design-system';
import { ApplicationsService } from '@tallo/investor/applications';
import { useNavigation } from '@tallo/investor/navigation';

import { headerTeleportSlot } from '../root/header-teleport-slot.const';

const route = useRoute();
const { goBack } = useNavigation();

const reportType = computed(() => route.params.reportType as TransUnionProductType);
const applicationId = computed(() => route.params.applicationId as string);

const reportRef = ref<string | undefined>(undefined);

watch(
  () => ({ reportType: reportType.value, applicationId: applicationId.value }),
  async ({ reportType, applicationId }) => {
    if (reportType && applicationId) {
      const { data } = await ApplicationsService.getReport(applicationId, reportType);
      reportRef.value = data;
    }
  },
  { immediate: true },
);
</script>

<style scoped lang="scss"></style>
